import { z } from "zod";

export const signDpaSchema = z.object({
  signerConfirmed: z
    .boolean()
    .refine((v) => v === true, "Confirm you are electronically signing this agreement"),
  adminOrOwnerConfirmed: z
    .boolean()
    .refine((v) => v === true, "Confirm you hold Administrator or Owner permissions"),
});

export type SignDpaValues = z.infer<typeof signDpaSchema>;
